/** @module csi/table/ChartController */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/action/Controller",
	"csi/html"
], function(declare, _, Controller, html) {

	var KEYS = {
		ChartName: "chartName",
		ChartPercentageDecimalPlaces: "chartPercentageDecimalPlaces",
		ChartSubName: "chartSubName",
		ChartTemplate: "chartTemplate",
		ChartGroupXHeading: "chartGroupX",
		ChartGroupYHeading: "chartGroupY",
		ChartValueHeading: "chartValue",
		ChartValue2Heading: "chartValue2",
		ChartXAxisName: "chartXAxisName",
		ChartYAxisName: "chartYAxisName",
		ChartShowLabels: "chartShowLabels",
		ChartShowValues: "chartShowValues",
		ChartShowPercentageValues: "chartShowPercentageValues",
		ChartSortBy: "chartSortBy"
	};

	return declare(Controller, {
		/** @property {number} chartIndex - index of chart in settings (-1 if creating new chart) */
		chartIndex: -1,

		/**
		 * Update charts when a chart is added or edited
		 */
		postProcessSuccess: function() {
			this.widget.redrawCharts();
		},

		/**
		 * Update chartSettings based on form data values.
		 */
		_onAction: function() {
			const view = this.widget;
			const settings = _.clone(view.get("chartSettings"));
			const chartValues = this._getChartValues();

			if (this.chartIndex >= 0) {
				if (chartValues) {
					// edit
					settings.splice(this.chartIndex, 1, chartValues);
				} else {
					// remove
					settings.splice(this.chartIndex, 1);
				}
			} else if (chartValues) {
				// create
				settings.push(chartValues);
			}

			view.set("chartSettings", settings);
		},

		/**
		 * Return object with values of all fields.
		 */
		_getChartValues: function() {
			var fd = this.m_formData;
			if (fd) {
				var values = {};

				_.each(fd.getFields(), function(field) {
					var name = KEYS[field.getControlName()];
					var value = field.getValue();
					values[name] = value;
				});

				return values;
			}

			return null;
		},

		/**
		 * Initialize form data with values from existing chart.
		 * @param {Object} chartValues
		 */
		_setChartInitialValues: function(chartValues) {
			var fd = this.m_formData;
			var attrs = _.invert(KEYS);

			_.each(chartValues, function(value, key) {
				fd.setFieldInitialValue(attrs[key], value);
			});
		}
	});
});